import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    subscriptionStatusConfirmationTexts: Object,
  };

  connect() {
    const nativeSelector = document.querySelector("#contact_upload_batch_sms_double_opt_in_status");
    if (!nativeSelector) {
      return;
    }

    // Very dumb, have to wait for selectize to initialize before we can use the select
    this.#waitForSelectize(nativeSelector).then((selectize) => {
      this.statusSelector = selectize;
      this.confirmationTextField = document.querySelector(
        "#contact_upload_batch_subscription_status_confirmation_text"
      );

      this.confirmationMessage = document.createElement("div");
      this.confirmationMessage.classList.add("text-sm", "text-gray-500", "italic");
      document
        .querySelector("input[name='contact_upload_batch[subscription_status_confirmation]']")
        .parentElement.appendChild(this.confirmationMessage);

      selectize.on("change", this.setMessage);
      this.setMessage(selectize.getValue());
    });
  }

  disconnect() {
    if (this.statusSelector) {
      this.statusSelector.off("change", this.setMessage);
    }
  }

  setMessage = (status) => {
    const message = this.subscriptionStatusConfirmationTextsValue[status];
    this.confirmationMessage.innerHTML = message;
    this.confirmationTextField.value = message;
  };

  #waitForSelectize(nativeSelector) {
    return new Promise((resolve) => {
      const interval = setInterval(() => {
        if (nativeSelector.selectize) {
          clearInterval(interval);
          resolve(nativeSelector.selectize);
        }
      }, 100);
    });
  }
}
